<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
  <dx-text-box [label]="'common.name' | translate | ucfirst" formControlName="name" formField required></dx-text-box>
  <dx-date-box [label]="'entity.companyExercice.start' | translate | ucfirst" formControlName="startDate" formField required></dx-date-box>
</form>